<template>
    <b-container fluid>
        <b-row class="no-gutters pt-2">
            <b-col md="12">
                <b-alert show v-if="metadata && metadata.damage_protection_test_mode" variant="warning">
                    Warning! Damage protection is in test mode. To issue live policies,
                    <a href="/app/damage-protection/setup/" target="_self"
                        >you must click on the issue live policies button.</a
                    >
                </b-alert>
                <grid
                    :isAutoWidth="true"
                    :isSearch="false"
                    ref="grid"
                    :rowData="rowData"
                    :columnDefs="damageColumnDefs"
                    class="metadata-grid mb-2"
                    :isAutoHeight="true"
                    rowSelection="single"
                    @selection-changed="handleRowSelect"
                    @on-row-data-updated="initialRowSelect"
                >
                </grid>

                <grid
                    v-if="selectedRow && rowData.length"
                    :isSearch="false"
                    ref="property_grid"
                    :rowData="properties"
                    :columnDefs="propertiesColumnDefs"
                    :isAutoHeight="true"
                    class="pt-2"
                >
                    <responsive-dropdown class="filter-dropdown" :items="propertiesFilterOptions" variant="default">
                        <span v-html="filterIcon" />{{ filterTitle }}
                    </responsive-dropdown>
                    <responsive-button @click="bulkAssignToProperty(true)" variant="default" :icon="['fas', 'plus']"
                        >Add "{{ truncatedTitle }}" to All Properties</responsive-button
                    >
                    <responsive-button @click="bulkAssignToProperty(false)" variant="default" :icon="['fas', 'minus']"
                        >Remove "{{ truncatedTitle }}" from All Properties</responsive-button
                    >
                </grid>
            </b-col>
        </b-row>
        <add-edit-damage-modal
            @hide="initialValues = null"
            :modalId="modalId"
            :initialData="initialValues"
            @submit="onAddEditRecord"
        />
    </b-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Grid from '../generic/grid/grid.vue';
    import { PROPERTY_MANAGER_DAMAGE_ENDPOINT } from '../../endpoints';
    import responsiveButton from '../generic/responsive-button/responsive-button.vue';
    import responsiveDropdown from '../generic/responsive-dropdown/responsive-dropdown.vue';
    import EditDeleteActionCellRenderer from './cell-renderers/edit-delete-action-cell-renderer.vue';
    import propertyManagerMixin from './property-manager-mixin';
    import AddEditDamageModal from './modals/add-edit-damage-modal.vue';

    export default {
        mixins: [propertyManagerMixin],
        components: { Grid, responsiveButton, responsiveDropdown, EditDeleteActionCellRenderer, AddEditDamageModal },
        data() {
            return {
                endpoint: PROPERTY_MANAGER_DAMAGE_ENDPOINT,
                propertyName: '',
            };
        },
        computed: {
            ...mapGetters('propertyManager', ['metadata']),
            damageColumnDefs() {
                return [
                    {
                        field: 'title',
                        headerName: 'Name',
                        sort: 'asc',
                        autoWidthExclude: true,
                        minWidth: 200,
                    },
                    {
                        field: 'group.name',
                        headerName: 'Group',
                    },
                    {
                        field: 'taxable_text',
                        headerName: 'Taxable',
                        cellRenderer: ({ data }) => data.taxable_text,
                        autoHeight: true,
                    },
                    {
                        field: 'collection_rules',
                        headerName: 'Collection Rules',
                    },
                    {
                        field: 'display_retail_cost',
                        headerName: 'Sugg. Retail',
                    },
                    {
                        field: 'display_wholesale_cost',
                        headerName: 'Wholesale',
                    },
                    {
                        field: 'display_value',
                        headerName: 'Current Value',
                    },
                    {
                        field: '',
                        cellRenderer: 'EditDeleteActionCellRenderer',
                        maxWidth: 210,
                        minWidth: 210,
                        cellRendererParams: {
                            onEdit: (data) => {
                                this.openEditFeeModal(data);
                            },
                        },
                    },
                ];
            },
        },
        mounted() {
            this.fetchRowData();
        },
        methods: {
            openEditFeeModal(data) {
                this.modalId = 'edit-damage-modal-' + data.id;
                this.initialValues = data;
                this.$nextTick(() => {
                    this.$bvModal.show(this.modalId);
                });
            },
        },
    };
</script>

<style scoped lang="scss">
    :deep(.metadata-grid) {
        display: inline;

        .ag-row-hover,
        .ag-row-selected {
            background: rgba(33, 150, 243, 0.1);
            cursor: pointer;
        }
    }

    .select-wrapper {
        display: flex;
        align-items: baseline;
        gap: 5px;

        span {
            width: 250px;
        }
    }
</style>
<style lang="scss">
    .filter-dropdown {
        a.dropdown-item {
            display: flex;
        }
    }
</style>
